/* global Headers */
import { getAccessToken, removeAccessToken, removeAuthCode, removeSignInWith } from './token.svc'

const apiBase = process.env.REACT_APP_API_BASE

const requestOptions = (method, body, tokenOverride) => {
  const headers = new Headers()
  const accessToken = tokenOverride || getAccessToken()
  if (accessToken) {
    headers.append('Authorization', `Bearer ${accessToken}`)
  }
  headers.append('Content-Type', `application/json`)
  let options = {
    method,
    headers,
  }
  if (body) {
    options = { ...options, body: JSON.stringify(body) }
  }
  return options
}

const request = async (url, method, body, tokenOverride) => {
  return await fetch(url, requestOptions(method, body, tokenOverride)).then(
    async (response) => {
      if (response.ok) {
        // 204 No Content (e.g. DELETE) has no body — skip JSON parsing
        if (response.status === 204 || response.headers.get('content-length') === '0') {
          return null
        }
        return response.json()
      }
      
      if (response.status === 401) {
        removeAccessToken()
        removeAuthCode()
        removeSignInWith()
        
        window.location.href = '/login'
        
        throw new Error('Your session has expired. Please log in again.')
      }
      throw new Error(await response.text())
    },
  )
}

export const Get = (endpoint, options = {}) => {
  if (options.rawResponse) {
    return fetch(`${apiBase}/${endpoint}`, requestOptions('GET'))
  }
  return request(`${apiBase}/${endpoint}`)
}

export const Post = (endpoint, body, tokenOverride) =>
  request(`${apiBase}/${endpoint}`, 'POST', body, tokenOverride)

export const Put = (endpoint, body) =>
  request(`${apiBase}/${endpoint}`, 'PUT', body)

export const Patch = (endpoint, body) =>
  request(`${apiBase}/${endpoint}`, 'PATCH', body)

export const Delete = (endpoint) => request(`${apiBase}/${endpoint}`, 'DELETE')
